'use strict';

/**
 * 查找指定事件类型的交互事件数据
 * */
exports.findEventByType = function (com, entryIndex, eventType) {
  var entry;
  var interactiveData;
  if (!com) {
    return null;
  }
  if (!entryIndex) {
    entryIndex = 0;
  }
  interactiveData = com.interactiveData;
  if (interactiveData) {
    if (entryIndex < interactiveData.entry.length) {
      entry = interactiveData.entry[entryIndex];
      if (entry && entry.events && entry.events.event) {
        for (var i = 0; i < entry.events.event.length; i++) {
          var evt = entry.events.event[i];
          if (evt.eventType === eventType) {
            if (evt.isChecked === 'True' || evt.isChecked) {
              return evt;
            } else {
              break;
            }
          }
        }
      }
    }
  }
  return null;
};


// WEBPACK FOOTER //
// ./src/helper/componentHelper.js